import React, { useState, useRef, useEffect } from 'react'
import axios from 'axios';
import Select from "react-select";
import DatePicker from 'react-datepicker';
import Loader from "../../../../../comman/Loader";
import {baseUrl, animalType, buySellType} from "../../../../../comman/config";
import { useNavigate, Link } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';


export default function Form({detail}) {
    const today = new Date().toISOString().split("T")[0];
    const [selectedDates, setSelectedDates] = useState([today]);
  
    const [formData, setFormData] = useState({
        date : [today],
        animal_type: '',
        animal_id : '',
        description : '',
       
    });
    const [validationErrors, setValidationErrors] = useState({
        date: false,
        animal_type: false,
        animal_id : false,
        description : false
    });
    const [popupOpen , setPopupOpen] = useState(false);
    const [animalList, setAnimalList] = useState([]);
    const formRef = useRef(null);
    
    
    const navigate = useNavigate();

    useEffect(() => {
        getAnimalList();
    }, [])
    useEffect(() => {
        
        if(detail){
            console.log();
            setSelectedDates(JSON.parse(detail[0].date))
            const animalObject = animalList.find((item) => item.animal_id == detail[0].animal_id);
            const animal = animalObject ? {value : animalObject.animal_id, label : animalObject.animal_id} : {value : "", label : ""};
            setFormData({
                date: JSON.parse(detail[0].date) || today,
                animal_type : animalType.find((val) => val.value == detail[0].animal_type) || '',
                animal_id: animal,
                description : detail[0].description || '',
                db_id: detail[0]?.id ?? 0
            });
        }
    }, [detail, animalList]);
  

    const getAnimalList = async () => {
        setPopupOpen(true);
        
        const response = await axios.get(`${baseUrl}/admin/profile/animal/animal_list`);
        setAnimalList(response.data.data);
        setPopupOpen(false);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newValidationErrors = {
            date: formData.date === '',
            animal_type : !formData.animal_type.value,
            animal_id : !formData.animal_id.value,
            description: formData.description === '',
           
        };
        setValidationErrors(newValidationErrors);
        const hasErrors = Object.values(newValidationErrors).some((error) => error);
        if (hasErrors) {
            
            // Find the first invalid input element
            const firstInvalidInput = formRef.current.querySelector('.invalid');
            if (firstInvalidInput) {
              // Scroll to the first invalid input element
              firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }else {
            console.log(formData);
            let url;
            try {
                setPopupOpen(true);
                if(detail){
                    url = `admin/farm/animal/health/edit/${detail[0].id}`;
                }else{
                    url = "admin/farm/animal/health/add";
                }
                console.log(url);
                await axios.post(`${baseUrl}/${url}`,{
                    formData: formData,
                });
                setPopupOpen(false);
                navigate("/admin/farm/animal/health");
            } catch (error) {

                setPopupOpen(false);
                console.log(error);
                
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
    
            }));
      
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [name]: false
        }));
    };

    const handleSelectChange = (data, option) => {
        if(option.name === "animal_type"){
            setFormData((prevData) => ({
                ...prevData,
                [option.name]: data,
                "animal_id" : ""
            }));
        
        }else{
            setFormData((prevData) => ({
                ...prevData,
                [option.name]: data,
            }));
        
        }
           
        
        
        
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [option.name]: false,
        }));
      };
    function convertToDateFormat(date) {
        // If the item is already a string, return it as is (assuming it's in the correct format)
        if (typeof date === 'string') {
            // Try to parse the string, if it's already in 'YYYY-MM-DD' format, return it
            const parsedDate = new Date(date);
            return parsedDate.toISOString().split('T')[0];  // Convert to 'YYYY-MM-DD' format
        }
        
        // If it's a Date object, format it to 'YYYY-MM-DD'
        if (date instanceof Date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');  // Months are 0-indexed
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;  // Format as 'YYYY-MM-DD'
        }
        
        return null;  // Return null for invalid input
    }
    const onDateChange = (dates) => {
        const formattedDateArray = dates.map(convertToDateFormat);
        setSelectedDates(formattedDateArray);
        setFormData((prevData) => ({
            ...prevData,
            "date": formattedDateArray,
    
        }));
       
    };
    

  return (
 
 <form ref={formRef}>
    {popupOpen && (
                     <Loader /> 
                ) }
                <div className="space-y-12">
                    <div>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="date" className="block text-sm font-medium leading-6 text-gray-900">Date</label>
                                <div className="mt-2">
                                    <DatePicker
                                      selectedDates={selectedDates}
                                      selectsMultiple
                                      onChange={onDateChange}
                                      shouldCloseOnSelect={false}
                                      className={`block w-full rounded-md border ${
                                        validationErrors.date ? "border-red-500" : "border-gray-300"
                                    } py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                      disabledKeyboardNavigation
                                    />
                                </div>
                                {validationErrors.date && <div className="text-red-500">Please enter a date.</div>}
                            </div>
                            
                        </div>
                       
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                        <div className="sm:col-span-2">
                                <label htmlFor="animal_type" className="block text-sm font-medium leading-6 text-gray-900">Animal Type</label>
                                <div className="mt-2">
                                    <Select
                                        classNamePrefix="select"
                                        value={formData.animal_type}
                                        name="animal_type"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={animalType.map((item) => ({
                                            value: item.value,
                                            label: item.label,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                </div>
                                {validationErrors.animal_type && <div className="text-red-500">Please select a animal type.</div>}
                            </div>
                        <div className="sm:col-span-2">
                                <label htmlFor="animal_id" className="block text-sm font-medium leading-6 text-gray-900">Animal Id</label>
                                <div className="mt-2">
                                    <Select
                                        classNamePrefix="select"
                                        value={formData.animal_id}
                                        name="animal_id"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={animalList.filter((val) => val.animal_type == (formData.animal_type.value)).map((item) => ({
                                            value: item.animal_id,
                                            label: item.animal_id,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                </div>
                                {validationErrors.animal_id && <div className="text-red-500">Please select a animal id.</div>}
                            </div>
                            
                            
                            
                         
                        </div>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                        
                            <div className="sm:col-span-2">
                                <label htmlFor="description" className="block text-sm font-medium leading-6 text-gray-900">Description</label>
                                <div className="mt-2">
                                    
                                <textarea
                                    id="description"
                                    name="description"
                                    placeholder="Description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    onWheel={(e) => e.target.blur()} // Prevent scrolling when using the wheel
                                    className={`block w-full rounded-md border ${validationErrors.description ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                    rows={4} // Adjust the number of visible rows as needed
                                />
                                    
                                </div>
                                {validationErrors.description && <div className="text-red-500">Please enter description.</div>}
                            </div>
                            <div className="sm:col-span-2">
    <label htmlFor="selectedDates" className="block text-sm font-medium leading-6 text-gray-900">
        Selected Dates:
    </label>
    <p className="mt-2 text-gray-900">
        {selectedDates.length > 0 ? selectedDates.join(', ') : 'No dates selected.'}
    </p>
</div>

                        </div>
                       

                        
                    </div>
                    
                </div>
                <div className="mt-6 flex items-center justify-end gap-x-6">
                    <Link to="/admin/farm/animal/buy_sell">
                        <button type="button" className="text-sm font-semibold leading-6 text-gray-900">Cancel</button>
                    </Link>
                    <button
                    onClick={handleSubmit}
                      type="submit"
                      className="rounded-md bg-blue-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Save
                    </button>
                </div>
            </form>
            )
        }